var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { title: _vm.title } }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { tile: "" } },
        [
          _c("DataSetFileActions", {
            attrs: {
              file: _vm.file,
              formFile: _vm.formFile,
              editForm: _vm.editForm,
            },
            on: {
              error: function ($event) {
                return _vm.handleMetadataUpdateError($event)
              },
              reload: function ($event) {
                return _vm.fetchFileById()
              },
              "update:edit": function ($event) {
                _vm.editForm = $event
              },
              "cancel:edit": function ($event) {
                return _vm.onFormCancel()
              },
            },
          }),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "card-bg-2" },
            [
              _vm.isLoading
                ? _c("PageLoader", {
                    staticClass: "my-5",
                    attrs: { "resource-name": "file details" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.metadataUpdateError
                ? _c("DataSetFileMetadataValidationResponse", {
                    staticClass: "mb-3",
                    attrs: {
                      label:
                        "File update is unsuccessful due to invalid metadata",
                      sublabel:
                        "Please review the error messages for more information. To discard modifications, please click Cancel.",
                      messages: _vm.metadataUpdateErrorMessages,
                      color: "red lighten-1",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.file && _vm.file.ValidationStatus == "Invalid"
                ? _c("DataSetFileMetadataValidationResponse", {
                    staticClass: "mb-3",
                    attrs: {
                      label: "File Metadata is invalid",
                      sublabel:
                        "Please review the error messages and modify the metadata fields accordingly.",
                      messages: _vm.file.ValidationMessages,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "max-width mb-3" },
                [
                  _c("Subheader", {
                    attrs: { dense: "", title: "File Information" },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-list",
                        { staticClass: "max-width", attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "tile-layout",
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "fill-height": "",
                                        "align-self-center": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "body-1 font-weight-medium",
                                          attrs: { xs4: "", md4: "" },
                                        },
                                        [_vm._v("File Name")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "body-1",
                                          attrs: { xs4: "", md6: "" },
                                        },
                                        [_vm._v(_vm._s(_vm.formFile.Name))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "tile-layout",
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "fill-height": "",
                                        "align-self-center": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "body-1 font-weight-medium",
                                          attrs: { xs4: "", md4: "" },
                                        },
                                        [_vm._v("File Id")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "body-1",
                                          attrs: { xs8: "", md8: "" },
                                        },
                                        [_vm._v(_vm._s(_vm.formFile.Id))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "tile-layout",
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "fill-height": "",
                                        "align-self-center": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "body-1 font-weight-medium",
                                          attrs: { xs4: "", md4: "" },
                                        },
                                        [_vm._v("File Size")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "body-1",
                                          attrs: { xs8: "", md8: "" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formFile.Size) + " Bytes"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "tile-layout",
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "fill-height": "",
                                        "align-self-center": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass:
                                            "body-1 font-weight-medium",
                                          attrs: { xs4: "", md4: "" },
                                        },
                                        [_vm._v("Date Created")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "body-1",
                                          attrs: { xs8: "", md8: "" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  _vm.formFile.DateCreated,
                                                  _vm.prettyDateTimeFormat,
                                                  { isUtc: true }
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.formFile.DeleteDateTime != null
                            ? _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass: "tile-layout",
                                          attrs: {
                                            row: "",
                                            wrap: "",
                                            "fill-height": "",
                                            "align-self-center": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "body-1 font-weight-medium",
                                              attrs: { xs4: "", md4: "" },
                                            },
                                            [_vm._v("Date Deleted")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "body-1",
                                              attrs: { xs8: "", md8: "" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      _vm.formFile
                                                        .DeletedDateTime,
                                                      _vm.prettyDateTimeFormat,
                                                      { isUtc: true }
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isValid
                ? _c("DataSetFileMetadataForm", {
                    attrs: {
                      edit: _vm.editForm,
                      "schema-id": _vm.formFile.SchemaId,
                      "metadata-fields": _vm.formFile.Metadata,
                    },
                    on: {
                      "input-field": function ($event) {
                        return _vm.onMetadataFormInput($event)
                      },
                      "input-schema": function ($event) {
                        return _vm.onMetadataSchemaInput($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }